var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_705_44704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.200195 10.0003C0.200195 4.59671 4.59665 0.200195 10.0002 0.200195C15.4037 0.200195 19.8002 4.59671 19.8002 10.0003C19.8002 15.4038 15.4037 19.8002 10.0002 19.8002C4.59665 19.8002 0.200195 15.4038 0.200195 10.0003ZM1.61838 10.0003C1.61838 14.6222 5.37822 18.382 10.0002 18.382C14.6221 18.382 18.382 14.6222 18.382 10.0003C18.382 5.37835 14.6222 1.61838 10.0002 1.61838C5.37822 1.61838 1.61838 5.37835 1.61838 10.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98828 5.45505C8.98828 4.89672 9.4425 4.44238 10.0002 4.44238C10.5578 4.44238 11.012 4.89672 11.012 5.45505C11.012 6.01261 10.558 6.46663 10.0002 6.46663C9.44233 6.46663 8.98828 6.01261 8.98828 5.45505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2915 9.39464C9.2915 9.00303 9.60899 8.68555 10.0006 8.68555C10.3922 8.68555 10.7097 9.00303 10.7097 9.39464V14.8492C10.7097 15.2408 10.3922 15.5583 10.0006 15.5583C9.60899 15.5583 9.2915 15.2408 9.2915 14.8492V9.39464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_44704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQicons);
export default __webpack_public_path__ + "static/media/qicons.580370bd882d52cf17739a6866b6e6ad.svg";
export { ForwardRef as ReactComponent };